// source: starlord/messages/response/application_assignment_response.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var starlord_messages_models_user_application_assigment_pb = require('../../../starlord/messages/models/user_application_assigment_pb.js');
goog.object.extend(proto, starlord_messages_models_user_application_assigment_pb);
var starlord_messages_models_name_id_model_pb = require('../../../starlord/messages/models/name_id_model_pb.js');
goog.object.extend(proto, starlord_messages_models_name_id_model_pb);
goog.exportSymbol('proto.ApplicationAssignmentResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ApplicationAssignmentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ApplicationAssignmentResponse.repeatedFields_, null);
};
goog.inherits(proto.ApplicationAssignmentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ApplicationAssignmentResponse.displayName = 'proto.ApplicationAssignmentResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ApplicationAssignmentResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ApplicationAssignmentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.ApplicationAssignmentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ApplicationAssignmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ApplicationAssignmentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    userassignmentsList: jspb.Message.toObjectList(msg.getUserassignmentsList(),
    starlord_messages_models_user_application_assigment_pb.UserApplicationAssignment.toObject, includeInstance),
    groupassignmentsList: jspb.Message.toObjectList(msg.getGroupassignmentsList(),
    starlord_messages_models_name_id_model_pb.NameIdModel.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ApplicationAssignmentResponse}
 */
proto.ApplicationAssignmentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ApplicationAssignmentResponse;
  return proto.ApplicationAssignmentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ApplicationAssignmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ApplicationAssignmentResponse}
 */
proto.ApplicationAssignmentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new starlord_messages_models_user_application_assigment_pb.UserApplicationAssignment;
      reader.readMessage(value,starlord_messages_models_user_application_assigment_pb.UserApplicationAssignment.deserializeBinaryFromReader);
      msg.addUserassignments(value);
      break;
    case 2:
      var value = new starlord_messages_models_name_id_model_pb.NameIdModel;
      reader.readMessage(value,starlord_messages_models_name_id_model_pb.NameIdModel.deserializeBinaryFromReader);
      msg.addGroupassignments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ApplicationAssignmentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ApplicationAssignmentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ApplicationAssignmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ApplicationAssignmentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserassignmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      starlord_messages_models_user_application_assigment_pb.UserApplicationAssignment.serializeBinaryToWriter
    );
  }
  f = message.getGroupassignmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      starlord_messages_models_name_id_model_pb.NameIdModel.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserApplicationAssignment userAssignments = 1;
 * @return {!Array<!proto.UserApplicationAssignment>}
 */
proto.ApplicationAssignmentResponse.prototype.getUserassignmentsList = function() {
  return /** @type{!Array<!proto.UserApplicationAssignment>} */ (
    jspb.Message.getRepeatedWrapperField(this, starlord_messages_models_user_application_assigment_pb.UserApplicationAssignment, 1));
};


/**
 * @param {!Array<!proto.UserApplicationAssignment>} value
 * @return {!proto.ApplicationAssignmentResponse} returns this
*/
proto.ApplicationAssignmentResponse.prototype.setUserassignmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.UserApplicationAssignment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.UserApplicationAssignment}
 */
proto.ApplicationAssignmentResponse.prototype.addUserassignments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.UserApplicationAssignment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ApplicationAssignmentResponse} returns this
 */
proto.ApplicationAssignmentResponse.prototype.clearUserassignmentsList = function() {
  return this.setUserassignmentsList([]);
};


/**
 * repeated NameIdModel groupAssignments = 2;
 * @return {!Array<!proto.NameIdModel>}
 */
proto.ApplicationAssignmentResponse.prototype.getGroupassignmentsList = function() {
  return /** @type{!Array<!proto.NameIdModel>} */ (
    jspb.Message.getRepeatedWrapperField(this, starlord_messages_models_name_id_model_pb.NameIdModel, 2));
};


/**
 * @param {!Array<!proto.NameIdModel>} value
 * @return {!proto.ApplicationAssignmentResponse} returns this
*/
proto.ApplicationAssignmentResponse.prototype.setGroupassignmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.NameIdModel=} opt_value
 * @param {number=} opt_index
 * @return {!proto.NameIdModel}
 */
proto.ApplicationAssignmentResponse.prototype.addGroupassignments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.NameIdModel, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ApplicationAssignmentResponse} returns this
 */
proto.ApplicationAssignmentResponse.prototype.clearGroupassignmentsList = function() {
  return this.setGroupassignmentsList([]);
};


goog.object.extend(exports, proto);
